import React from "react";
import styled from 'styled-components';

import { Button } from "./Button";
import { LabeledData } from "./LabeledData";
import { LabeledDataRow } from "./LabeledDataRow";
import { HeroParagraph, MainTitle } from "../theme/typography";

import ServalVideo from '../images/serval/video-website-low.mp4';
import products from '../data/products.json';

const StyledServalBlock = styled.div`
	background-color: #000;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	min-height: calc(100dvh - 3rem);
	overflow: hidden;
	padding: 1.75rem 1.5rem;
	position: relative;
	text-align: center;
	z-index: 0;

	@media screen and (orientation:landscape) {
		justify-content: center;
		text-align: left;
	}

	@media screen and (min-width: ${(props) => props.theme.breakpoints.third}) {
		padding: 1.75rem 3rem;
	}
`;

const TopContent = styled.div`
	z-index: 1;
	
	@media only screen and (min-width: ${(props) => props.theme.breakpoints.third}) {
		width: 32rem;
	}
`;

const BottomContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	z-index: 1;

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.third}) {
		align-items: flex-start;
		width: 32rem;
	}
`;

const PriceRow = styled(LabeledDataRow)`
	width: 100%;

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.first}) {
		max-width: 24rem;
	}

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.third}) {
		max-width: 32rem;
	}
`;

const ButtonContainer = styled.div`
	margin-top: 1.5rem;
	width: 100%;

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.first}) {
		display: flex;
		justify-content: center;
	}

	@media screen and (orientation:landscape) {
		justify-content: flex-start;
	}
`;

const BuyButton = styled(Button)`

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.first}) {
		flex: 0 0 auto;
	}
`;

const StyledVideo = styled.video`
	height: 100%;
	left: 50%;
	object-fit: cover;
	position: absolute;
	top: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	z-index: -1;
`;

const ButtonAndDescription = styled.div``;

export const ServalHeaderBlock = React.forwardRef((props, ref) => {
	return <ServalHeaderBlockClass {...props} forwardedRef={ref} />;
});

class ServalHeaderBlockClass extends React.Component {
	render() {
		const data = products.find((product) => product.id === "serval");

		return (
			<StyledServalBlock ref={this.props.forwardedRef}>
				<StyledVideo 
					autoPlay 
					loop 
					muted
					playsInline
					src={ServalVideo}
				></StyledVideo>
				<TopContent>
					<MainTitle>{data.name}</MainTitle>
					<HeroParagraph>A perfectly balanced 5-inch racing frame. Tough, practical, easy to build, and fully open source.</HeroParagraph>
				</TopContent>
				<BottomContent>
					{data.versions.map((version) => (
						<PriceRow key={version.versionNumber}>
							{version.prices.map((price) => (
								<LabeledData
									key={`${price.priceName} ${version.versionNumber}`}
									label={`${price.priceName} ${version.versionNumber}`}
									data={`~€${price.priceEUR}`}
									description={`${price.priceHUF} HUF`}
								/>
							))}
						</PriceRow>
					))}
					<ButtonAndDescription>
						<ButtonContainer>
							<BuyButton 
								label={`Buy a Serval`} 
								link={data.buyLink} 
							/>
						</ButtonContainer>
					</ButtonAndDescription>
				</BottomContent>
			</StyledServalBlock>
		);
	}
}